import type {
    AutoResponsivenessMode as AutoResponsivenessModeType,
    BindingType as BindingTypeAlias,
    ArgumentType as ArgumentTypeAlias,
    ConnectionType,
    DomOrderStrategy as DomOrderStrategyType,
    LayoutIntentType as LayoutIntentTypeAlias,
    MobileAlgoConditionType as MobileAlgoConditionTypeAlias,
    VariableReferenceNamespace as VariableReferenceNamespaceType,
    BindingsConfigType as BindingsConfigTypeAlias,
    BindingItemType as BindingItemTypeAlias,
    TemplateItemBindingType as TemplateItemBindingTypeAlias,
    RuntimeBindingsConfigType as RuntimeBindingsConfigTypeAlias
} from '@wix/document-services-types'

export const VariableReferenceNamespace = {
    CSS_STYLE: 'cssStyle',
    LAYOUT: 'layout',
    VARIABLES: 'variables'
} as const satisfies Record<string, VariableReferenceNamespaceType>

export const OperationStatus = {
    FAILED: 'FAILED',
    READY: 'READY',
    PENDING: 'PENDING'
} as const

export const FileMediaType = {
    UNKNOWN: 'UNKNOWN',
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    DOCUMENT: 'DOCUMENT',
    VECTOR: 'VECTOR',
    ARCHIVE: 'ARCHIVE',
    MODEL3D: 'MODEL3D',
    OTHER: 'OTHER',
    ICON: 'ICON'
} as const

export const AutoResponsivenessMode = {
    Adaptive: 'adaptive',
    Flush: 'flush'
} as const satisfies Record<string, AutoResponsivenessModeType>

export const LayoutIntentType = {
    SuperGrid: 'SuperGrid',
    CssGrid: 'CssGrid',
    Mesh: 'Mesh',
    SimpleGrid: 'SimpleGrid'
} as const satisfies Record<string, LayoutIntentTypeAlias>

export const DomOrderStrategy = {
    NShape: 'N-shape',
    ZShape: 'Z-shape'
} as const satisfies Record<string, DomOrderStrategyType>

export const MobileAlgoConditionType = {
    Publish: 'publish',
    RevisionSave: 'revision_save',
    Manual: 'manual',
    Unknown: 'unknown'
} as const satisfies Record<string, MobileAlgoConditionTypeAlias>

export const ConnectionTypes = {
    WixCodeConnectionItem: 'WixCodeConnectionItem',
    ConnectionItem: 'ConnectionItem'
} as const satisfies Record<string, ConnectionType>

export const ArgumentType = {
    Static: 'StaticArgItem',
    ContextBindingItem: 'ContextBindingItem',
    FunctionBinding: 'FunctionBindingItem',
    TemplateBindingItem: 'TemplateBindingItem'
} as const satisfies Record<string, ArgumentTypeAlias>

export const BindingType = {
    ContextProvider: 'ContextProvider',
    FunctionLibrary: 'FunctionLibrary',
    Template: 'Template'
} as const satisfies Record<string, BindingTypeAlias>

export const BindingsConfigType = {
    ContextBinding: 'ContextBindingConfig',
    FunctionBinding: 'FunctionBindingConfig',
    TemplateBinding: 'TemplateBindingConfig'
} as const satisfies Record<string, BindingsConfigTypeAlias>

export const RuntimeBindingsConfigType = {
    ContextBinding: 'RuntimeContextBindingConfig',
    FunctionBinding: 'RuntimeFunctionBindingConfig',
    TemplateBinding: 'RuntimeTemplateBindingConfig'
} as const satisfies Record<string, RuntimeBindingsConfigTypeAlias>

export const BindingItemType = {
    ContextItem: 'ContextItem',
    ContextMethod: 'ContextMethod'
} as const satisfies Record<string, BindingItemTypeAlias>

export const TemplateBindingType = {
    TemplateItem: 'TemplateItem',
    TemplateMethod: 'TemplateMethod',
    TemplateIndex: 'TemplateIndex',
    TemplateLength: 'TemplateLength'
} as const satisfies Record<string, TemplateItemBindingTypeAlias>
